import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../shared/material/material.module';
import { NgxMaskModule } from 'ngx-mask';
import { SearchRoutingModule } from './search-routing.module';
import { SearchComponent } from './search.component';
import { StudentSearchComponent } from './pages/student-search.component';
import { SearchSidenavComponent } from './component/sidenav/search-sdenav.component';
import { SharedModule } from '../shared/shared.module';
import { AddStudentDialog } from './dialogs/add-student-dialog.component';


@NgModule({
    imports: [   
        SharedModule,
        CommonModule, 
        SearchRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatDatepickerModule, 
        MatMomentDateModule,
        NgxMaskModule.forRoot()
       ],
    exports: [SearchSidenavComponent, StudentSearchComponent],
    declarations: [
       SearchComponent,StudentSearchComponent,SearchSidenavComponent,AddStudentDialog,
    ],
    providers: [],
})
export class SearchModule { }
